import { RoleContext } from "@vega-api/generated/types/roleContext";
import { SubjectType } from "@vega-api/generated/types/subjectType";
import { LinkTextButton } from "@vega-core/components/Buttons/LinkTextButton";
import { LoadingSpinner } from "@vega-core/components/Loaders/LoadingSpinner/LoadingSpinner";
import { useBoolean } from "@vega-core/hooks/useBoolean";
import { m } from "@vega-core/paraglide/messages";
import { buildTimeFlags } from "@vega-core/utils/buildTimeFlags";

import { PermissionsHelpModal } from "../../components/PermissionsHelpModal/PermissionsHelpModal";
import { SettingsSectionLayout } from "../../components/SettingsSectionLayout";

import { MyFundsList } from "./components/MyFundsList";
import { useMyAccessData } from "./useMyAccessData";

export const MyAccess = () => {
  const { isLoading, isFetched, userPermissions } = useMyAccessData();
  const isPermissionsHelpOpen = useBoolean(false);

  return (
    <>
      {isLoading && !isFetched ? <LoadingSpinner /> : null}
      <div className="flex flex-col gap-6 w-full">
        <p className="body-base-regular text-text/secondary">
          {m.settings_myAccess_description()}{" "}
          <LinkTextButton
            onClick={isPermissionsHelpOpen.setTrue}
            text={m.userManagement_permissions_moreAboutRoles()}
          />
        </p>

        <div className="flex flex-col gap-4">
          <h2 className="body-base-semibold text-text/primary">
            {m.userManagement_permissions_offerings()}
          </h2>
          <SettingsSectionLayout className="p-0">
            <MyFundsList
              isLoading={isLoading}
              itemsTitle={m.userManagement_permissions_offerings()}
              permissions={userPermissions}
              roleContext={RoleContext.PRE_INVESTMENT}
              subjectType={SubjectType.OPPORTUNITY}
            />
          </SettingsSectionLayout>
        </div>

        {buildTimeFlags.reporting_settings_investments ? (
          <div className="flex flex-col gap-4">
            <h2 className="body-base-semibold text-text/primary">
              {m.userManagement_permissions_investments()}
            </h2>
            <SettingsSectionLayout className="p-0">
              <MyFundsList
                isLoading={isLoading}
                itemsTitle={m.userManagement_permissions_investments()}
                permissions={userPermissions}
                roleContext={RoleContext.POST_INVESTMENT}
                subjectType={SubjectType.INVESTMENT}
              />
            </SettingsSectionLayout>
          </div>
        ) : null}
      </div>
      <PermissionsHelpModal
        isOpen={isPermissionsHelpOpen.value}
        onClose={isPermissionsHelpOpen.setFalse}
      />
    </>
  );
};
